export const EmptyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="mx-auto h-12 w-12 text-neutral-400"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
    />
  </svg>
);

export const At = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    {...props}
  >
    <path
      d="M15.8571 12C15.8571 14.1302 14.1302 15.8571 12 15.8571C9.86976 15.8571 8.14286 14.1302 8.14286 12C8.14286 9.86972 9.86976 8.14282 12 8.14282C14.1302 8.14282 15.8571 9.86972 15.8571 12ZM15.8571 12L15.8571 13.2857C15.8571 14.7059 17.0084 15.8571 18.4286 15.8571C19.3408 15.8571 20.1422 15.3821 20.5986 14.6658C20.8528 14.2671 21 13.7936 21 13.2857V12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C13.9122 21 15.6851 20.4037 17.1429 19.3868"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Heart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    {...props}
  >
    <path
      d="M4.3314 12.0474L12 20L19.6686 12.0474C20.5211 11.1633 21 9.96429 21 8.71405C21 6.11055 18.9648 4 16.4543 4C15.2487 4 14.0925 4.49666 13.24 5.38071L12 6.66667L10.76 5.38071C9.90749 4.49666 8.75128 4 7.54569 4C5.03517 4 3 6.11055 3 8.71405C3 9.96429 3.47892 11.1633 4.3314 12.0474Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12 4V20M12 4L18 10M12 4L6 10"
      className="stroke-current"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowCircleRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M17 12H7M17 12L13 16M17 12L13 8M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      className="stroke-current"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Star = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 17L6 20L7.5 14L3 9L9.5 8.5L12 3L14.5 8.5L21 9L16.5 14L18 20L12 17Z" />
  </svg>
);

export const User = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M16 15H8C5.79086 15 4 16.7909 4 19V21H20V19C20 16.7909 18.2091 15 16 15Z"
      className="stroke-current"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
      className="stroke-current"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Email = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M3.29289 5.29289C3.47386 5.11193 3.72386 5 4 5H20C20.2761 5 20.5261 5.11193 20.7071 5.29289M3.29289 5.29289C3.11193 5.47386 3 5.72386 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.72386 20.8881 5.47386 20.7071 5.29289M3.29289 5.29289L10.5858 12.5857C11.3668 13.3668 12.6332 13.3668 13.4142 12.5857L20.7071 5.29289"
      className="stroke-current"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Instagram = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12.0039 0C6.99403 0 5.52883 0.00516967 5.24402 0.0288024C4.2159 0.114287 3.57615 0.276208 2.87917 0.623314C2.34204 0.890106 1.91843 1.19936 1.50035 1.63288C0.738959 2.42347 0.277507 3.3961 0.110461 4.55226C0.0292458 5.11354 0.00561946 5.22801 0.000820359 8.09496C-0.00102545 9.05061 0.000820359 10.3083 0.000820359 11.9953C0.000820359 17.0025 0.00635778 18.4666 0.0303533 18.7509C0.113415 19.7516 0.270308 20.3812 0.602553 21.0699C1.23751 22.3882 2.45021 23.3778 3.87886 23.7471C4.37354 23.8745 4.9199 23.9446 5.6213 23.9778C5.91848 23.9908 8.94744 24 11.9783 24C15.0091 24 18.0399 23.9963 18.3297 23.9815C19.1418 23.9433 19.6134 23.88 20.1349 23.7452C20.8433 23.5635 21.5035 23.2293 22.0693 22.7659C22.6352 22.3026 23.0932 21.7212 23.4112 21.0625C23.737 20.3905 23.9022 19.7369 23.9769 18.7884C23.9932 18.5816 24 15.2847 24 11.9922C24 8.69907 23.9926 5.40821 23.9764 5.20142C23.9007 4.23765 23.7355 3.5896 23.3992 2.90461C23.1232 2.34389 22.8168 1.92515 22.372 1.49699C21.5783 0.738524 20.6074 0.276947 19.4503 0.11004C18.8897 0.0289871 18.778 0.00498504 15.9096 0H12.0039Z"
      fill="url(#paint0_radial_609_1960)"
    />
    <path
      d="M12.0006 3C9.55631 3 9.24956 3.01069 8.28956 3.05438C7.33144 3.09825 6.67744 3.24994 6.10519 3.4725C5.51325 3.70238 5.01112 4.00988 4.51087 4.51031C4.01025 5.01056 3.70275 5.51269 3.47212 6.10444C3.249 6.67687 3.09713 7.33106 3.054 8.28881C3.01125 9.24881 3 9.55575 3 12C3 14.4443 3.01088 14.7501 3.05438 15.7101C3.09844 16.6682 3.25013 17.3222 3.4725 17.8944C3.70256 18.4864 4.01006 18.9885 4.5105 19.4888C5.01056 19.9894 5.51269 20.2976 6.10425 20.5275C6.67687 20.7501 7.33106 20.9018 8.289 20.9456C9.249 20.9893 9.55556 21 11.9996 21C14.4441 21 14.7499 20.9893 15.7099 20.9456C16.668 20.9018 17.3227 20.7501 17.8954 20.5275C18.4871 20.2976 18.9885 19.9894 19.4886 19.4888C19.9892 18.9885 20.2967 18.4864 20.5273 17.8946C20.7486 17.3222 20.9004 16.668 20.9454 15.7103C20.9886 14.7503 20.9998 14.4443 20.9998 12C20.9998 9.55575 20.9886 9.249 20.9454 8.289C20.9004 7.33087 20.7486 6.67687 20.5273 6.10462C20.2967 5.51269 19.9892 5.01056 19.4886 4.51031C18.9879 4.00969 18.4873 3.70219 17.8948 3.4725C17.3211 3.24994 16.6667 3.09825 15.7086 3.05438C14.7486 3.01069 14.4429 3 11.9979 3H12.0006ZM11.1932 4.62187C11.4328 4.6215 11.7002 4.62187 12.0006 4.62187C14.4036 4.62187 14.6884 4.6305 15.6373 4.67363C16.5148 4.71375 16.9911 4.86038 17.3083 4.98356C17.7283 5.14669 18.0277 5.34169 18.3426 5.65669C18.6576 5.97169 18.8526 6.27169 19.0161 6.69169C19.1392 7.00856 19.2861 7.48481 19.326 8.36231C19.3691 9.31106 19.3785 9.59606 19.3785 11.9979C19.3785 14.3998 19.3691 14.6848 19.326 15.6336C19.2859 16.5111 19.1392 16.9873 19.0161 17.3042C18.8529 17.7242 18.6576 18.0233 18.3426 18.3381C18.0276 18.6531 17.7285 18.8481 17.3083 19.0112C16.9914 19.1349 16.5148 19.2812 15.6373 19.3213C14.6886 19.3644 14.4036 19.3738 12.0006 19.3738C9.59737 19.3738 9.31256 19.3644 8.36381 19.3213C7.48631 19.2808 7.01006 19.1342 6.69262 19.011C6.27262 18.8479 5.97262 18.6529 5.65762 18.3379C5.34262 18.0229 5.14762 17.7236 4.98413 17.3034C4.86094 16.9866 4.71413 16.5103 4.67419 15.6328C4.63106 14.6841 4.62244 14.3991 4.62244 11.9957C4.62244 9.59231 4.63106 9.30881 4.67419 8.36006C4.71431 7.48256 4.86094 7.00631 4.98413 6.68906C5.14725 6.26906 5.34262 5.96906 5.65762 5.65406C5.97262 5.33906 6.27262 5.14406 6.69262 4.98056C7.00987 4.85681 7.48631 4.71056 8.36381 4.67025C9.19406 4.63275 9.51581 4.6215 11.1932 4.61963V4.62187ZM16.8047 6.11625C16.5911 6.11625 16.3822 6.1796 16.2046 6.29829C16.027 6.41698 15.8886 6.58567 15.8069 6.78304C15.7251 6.9804 15.7038 7.19758 15.7455 7.40709C15.7872 7.6166 15.8901 7.80903 16.0411 7.96006C16.1922 8.11108 16.3847 8.21391 16.5942 8.25554C16.8037 8.29717 17.0209 8.27573 17.2182 8.19393C17.4156 8.11213 17.5842 7.97365 17.7029 7.79599C17.8215 7.61834 17.8848 7.40949 17.8847 7.19587C17.8847 6.59962 17.4009 6.11588 16.8047 6.11588V6.11625ZM12.0006 7.37812C9.44812 7.37812 7.37869 9.44756 7.37869 12C7.37869 14.5524 9.44812 16.6209 12.0006 16.6209C14.553 16.6209 16.6219 14.5524 16.6219 12C16.6219 9.44756 14.553 7.37812 12.0006 7.37812ZM12.0006 9C13.6573 9 15.0006 10.3431 15.0006 12C15.0006 13.6567 13.6573 15 12.0006 15C10.3436 15 9.00056 13.6567 9.00056 12C9.00056 10.3431 10.3436 9 12.0006 9Z"
      fill="white"
    />
    <defs>
      <radialGradient
        id="paint0_radial_609_1960"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.37503 25.8485) rotate(-90) scale(23.7858 22.1226)"
      >
        <stop stop-color="#FFDD55" />
        <stop offset="0.1" stop-color="#FFDD55" />
        <stop offset="0.5" stop-color="#FF543E" />
        <stop offset="1" stop-color="#C837AB" />
      </radialGradient>
    </defs>
  </svg>
);
